import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col, Button, Table, Form, InputGroup, Card, Modal } from "react-bootstrap";
import { FaPlus, FaSearch, FaShoppingCart, FaTrash } from "react-icons/fa";
import { BiRupee } from "react-icons/bi";
import { RiSave3Line } from "react-icons/ri";
import { LuPrinter } from "react-icons/lu";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";


const EditPOS = () => {
  // const [packingCharge, setPackingCharge] = useState(0.00);
    const [vehicleNumber, setVehicleNumber] = useState("");
  
  const [userData, setUserData] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const { order_id } = useParams();
  const [cart, setCart] = useState([]);
  const [productName, setProductName] = useState("");
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");
  const nameRef = useRef(null);
  const priceRef = useRef(null);
  const qtyRef = useRef(null);

  const [filteredCodes, setFilteredCodes] = useState([]);
  const [products, setProducts] = useState([]);
  const [fullproducts, setFullProducts] = useState([]);
  const [productCode, setProductCode] = useState("");
  const [hsnCode, setHsnCode] = useState("");
  const [loading, setLoading] = useState(true);
  const [Loading1, setLoading1] = useState();
  const [Loading2, setLoading2] = useState();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [agent, setAgent] = useState([]);
  const [gst, setGST] = useState({ cgst: "0", sgst: "0", packingCharge: "0.00" });

  const [customer, setCustomer] = useState([]);
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    customerName: "",
    agent: "",
    address: "",
    phonenumber: "",
    // creditlimit:"",
    gstin: "",
    aadhar_number: "",
    state: "",
  });
  console.log(searchTerm);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  // Handle Form Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    const payload = {
      name: formData.customerName,
      // credit_limit: formData.creditlimit,  // FIXED
      tax_number: formData.gstin,      // FIXED
      aadhar_number: formData.aadhar_number,
      telephone: formData.phonenumber,        // FIXED
      address: formData.address,
      agent: formData.agent,
      state: formData.state
    };

    console.log("Payload:", payload);

    try {
      const response = await fetch(`${API_BASE_URL}customer_add.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("API Response:", data);

      if (data.head.code === 200) {
        alert("Customer added successfully!");
        setShow(false);
        window.location.reload();
      } else {
        alert("Failed to add customer. Error: " + data.head.msg);
      }
    } catch (error) {
      console.error("Network/API Error:", error);
      alert("Required field is empty");
    }
  };

  useEffect(() => {
    axios.post(`${API_BASE_URL}order_details.php`, { order_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          const userId = response.data.body.user_id;
          console.log("====================", userId);
          const matchedUser = customer.find((c) => c.user_id === userId);

          setCart(response.data.body.order_details);
          // ✅ Get packing charge from API
          let packingCharge = parseFloat(response.data.body.packing_charge);
          setUserData(response.data.body);
          setVehicleNumber(response.data.body.vehicle_number); // Reset vehicle number
          setSelectedCustomer(matchedUser || null); // ✅ Now sets full object
          console.log("User Data:", matchedUser);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
      });
  }, [API_BASE_URL, order_id, customer]);

  useEffect(() => {
    const fetchAgent = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}agent_list.php`);
        if (response.data.head.code === 200) {
          setAgent(response.data.body);
        } else {
          console.error("Error fetching agent list:", response.data.head.msg);
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    };

    fetchAgent();
  }, []); // ✅ Empty array to run only once on mount

  useEffect(() => {
    setLoading(true);
    axios.post(`${API_BASE_URL}pos_api/pos_product_list.php`)
      .then((response) => {
        if (response.data.head.code === 200) {
          setProducts(response.data.body.product);
          setFullProducts(response.data.body.product);
          setCustomer(response.data.body.customer);
          setHsnCode(response.data.body.customer[0]?.hsn_code);
          console.log("HSN Code:", hsnCode);
          // setHsnCode(response.data.body.customer[0].hsnOcode);

          // Extract and store GST details
          const gstData = response.data.body.gst;
          if (gstData) {
            setGST({
              cgst: gstData.cgst,
              sgst: gstData.sgst,
              packingCharge: gstData.packing_charge
            });
            console.log(gstData);

          }
        } else {
          console.error("Error Fetching Data", response.data.head.msg);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 500); // Delay for better UI
      });
  }, []);



  // Handle product code input with dropdown suggestion
  const handleCodeInput = (event) => {
    const code = event.target.value.trim().toUpperCase();
    setProductCode(code);

    if (code.length === 0) {
      setFilteredCodes([]);
      setProductName("");
      return;
    }

    // Filter products for dropdown suggestions
    const filtered = products.filter((p) => p.sno.includes(code));
    setFilteredCodes(filtered);

    // Find exact match when full code is entered
    const product = products.find((p) => p.sno === code);

    if (product) {
      setFilteredCodes([]); // Close dropdown

      // if (!product.stock || product.stock <= 0) {
      //   alert(`"${product.product_name}" is out of stock!`);
      //   setProductName(""); // Clear product name to prevent selection
      //   return;
      // }

      setProductName(product.product_name);
      addToCart(product); // ✅ Add only if in stock
    } else {
      setProductName(""); // Clear if no exact match
    }
  };


  // Handle dropdown selection
  const handleDropdownSelect = (product) => {
    setFilteredCodes([]); // Close dropdown

    // Ensure product is valid
    if (!product || !product.sno || !product.product_name) {
      alert("Invalid product selection!");
      return;
    }

    // Strict stock check
    // if (!product.stock || product.stock <= 0) {
    //   alert(`"${product.product_name}" is out of stock!`);
    //   return;
    // }

    setProductCode(product.sno);
    setProductName(product.product_name);
    addToCart(product); // ✅ Add to cart only if in stock
  };



  // Handle Product Name Input
  const handleNameInput = (event) => {
    const name = event.target.value.trim();
    setProductName(name);

    if (!products.length) return; // Ensure products are loaded

    // Find product ignoring case and trimming spaces
    const product = products.find((p) => p.product_name.trim().toLowerCase() === name.toLowerCase());

    console.log("Selected Name:", name);
    console.log("Matching Product:", product);

    if (product) {
      if (!product.product_name) {
        alert("Invalid product details!");
        setProductCode("");
        setProductName("");
        return;
      }

      // if (!product.stock || product.stock <= 0) {
      //     alert(`"${product.product_name}" is out of stock!`);
      //     setProductCode("");
      //     setProductName("");
      //     return;
      // }

      setProductCode(product.sno);
      addToCart(product);
    } else {
      setProductCode("");
    }
  };



  // Add Product to Cart
  const addToCart = (product) => {
    // if (product.stock === 0) {
    //   alert(`"${product.product_name}" is out of stock!`);
    //   return; // Prevent adding to cart
    // }

    setCart((prevCart) => {
      const existingProduct = prevCart.find((item) => item.product_id === product.product_id);
      if (existingProduct) {
        // if (existingProduct.qty + 1 > product.stock) {
        //   alert(`Only ${product.stock} items available in stock!`);
        //   return prevCart;
        // }
        return prevCart.map((item) =>
          item.product_id === product.product_id ? { ...item, qty: existingProduct.qty + 1 } : item
        );
      } else {
        return [...prevCart, { ...product, qty: 1 }];
      }
    });
  };


  const handleQtyChange = (e, product) => {
    let prevQty = product.qty; // Store previous quantity
    let newQty = e.target.value.replace(/^0+/, ""); // Remove leading zeros

    if (newQty === "" || isNaN(newQty)) {
      newQty = "";
    } else {
      newQty = parseInt(newQty, 10);

      // ✅ Ensure new quantity is not less than 1
      if (newQty < 1) {
        newQty = 1;
      }

      // ✅ Handle stock limit and show alert correctly
      // if (newQty > product.stock) {
      //     alert(`Only ${product.stock} items available in stock!`);
      //     newQty = product.stock; // Reset to max stock
      // }
    }

    // ✅ Update state correctly
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.product_id === product.product_id ? { ...item, qty: newQty } : item
      )
    );
  };

  // ✅ Ensure Minimum Quantity = 1 on Blur
  // const handleQtyBlur = (e, product) => {
  //     let newQty = parseInt(e.target.value, 10) || 1;
  //     if (newQty < 1) newQty = 1;

  //     setCart((prevCart) =>
  //         prevCart.map((item) =>
  //             item.product_id === product.product_id ? { ...item, qty: newQty } : item
  //         )
  //     );
  // };
  const calculateTotal = () => {
    return cart.reduce((total, item) => {
      return total + item.buy_price * item.qty;
      // return total + parseFloat(item.buy_price || 0);
    }, 0) || 0;
  };

  // Get CGST and SGST from the API response
  const cgstAmount = (calculateTotal() * (parseFloat(gst.cgst) / 100));
  const sgstAmount = (calculateTotal() * (parseFloat(gst.sgst) / 100));
  const IgstAmount = cgstAmount + sgstAmount;
  // Convert packing charge from string to float
  let packingCharge = gst.packingCharge
    ? (parseFloat(gst.packingCharge) / 100) * calculateTotal()
    : 0;
  // Calculate Grand Total
  //   const grandtotal = Math.round(calculateTotal() + cgstAmount + sgstAmount + packingCharge);
  const total = parseFloat(calculateTotal()) || 0;
  const cgst = parseFloat(cgstAmount) || 0;
  const sgst = parseFloat(sgstAmount) || 0;
  const packing = parseFloat(packingCharge) || 0;

  const grandtotal = Math.round(total + cgst + sgst + packing);

  // ✅ Console Debugging
  //   console.log("Subtotal:", calculateTotal().toFixed(2));
  console.log("CGST (" + gst.cgst + "%):", cgstAmount.toFixed(2));
  console.log("SGST (" + gst.sgst + "%):", sgstAmount.toFixed(2));
  console.log("Packing Charge:", packingCharge.toFixed(2));
  console.log("Grand Total:", grandtotal);





  const handleSave = () => {
    if (!selectedCustomer) {
      alert("Please select a customer.");
      return;
    }
    setLoading1(true);
    if (!cart || cart.length === 0) {
      alert("Please select a product");
      return;
    }


    const orderData = {
      order_id: order_id,
      user_id: selectedCustomer.user_id,
      billing_name: selectedCustomer.name,
      billing_phonenumber: selectedCustomer.telephone,
      billing_state: selectedCustomer.state,
      total: grandtotal,
            vehicle_number: vehicleNumber, // Add vehicle number to order data

      subtotal: calculateTotal(),
      cgst: cgstAmount,
      sgst: sgstAmount,
      packing_charge: packingCharge,
      productdetails: cart.map(item => ({
        od_id: item.order_detail_id ?? "",
        product_id: item.product_id,
        product_name: item.product_name,
        rate_per: item.rate_per,
        box_contents: item.box_contents,
        qty: item.qty,
        unit: item.unit,
        amount_per_product: item.buy_price,
        total_per_product: item.buy_price * item.qty,

      }))
    };
    console.log(orderData);
    axios.post(`${API_BASE_URL}pos_api/pos_order_edit.php`, orderData)

      .then(response => {
        if (response.data.head.code === 200) {
          console.log("Order Saved:", response.data);
          alert("Order saved successfully!");
          setCart([]);
          setVehicleNumber(""); // Reset vehicle number
          //   window.location.reload();
          window.history.back();

        } else {
          console.log("Error", response.data.head.msg)
        }

      })
      .catch(error => {
        console.error("Save Order Error:", error);
        alert("Failed to save order.");
      }).finally(() => {
        setLoading1(false);
      });
  };



  const handleSavePrint = () => {

    // ✅ Open invoice print page with order details (separate tab)
    // const printWindow = window.open('/invoiceprint', '_blank');

    if (!selectedCustomer) {
      alert("Please select a customer.");
      return;
    }
    setLoading2(true);
    if (!cart || cart.length === 0) {
      alert("Please select a product");
      return;
    }


    const orderData = {
      order_id: order_id,
      user_id: selectedCustomer.user_id,
      billing_name: selectedCustomer.name,
      billing_phonenumber: selectedCustomer.telephone,
      billing_state: selectedCustomer.state,
      total: grandtotal,
      vehicle_number: vehicleNumber, // Add vehicle number to order data
      subtotal: calculateTotal(),
      cgst: cgstAmount,
      sgst: sgstAmount,
      packing_charge: packingCharge,
      productdetails: cart.map(item => ({
        od_id: item.order_detail_id ?? "",
        product_id: item.product_id,
        product_name: item.product_name,
        rate_per: item.rate_per,
        box_contents: item.box_contents,
        qty: item.qty,
        unit: item.unit,
        amount_per_product: item.buy_price,
        total_per_product: item.buy_price * item.qty,

      }))
    };
    console.log(orderData);
    axios.post(`${API_BASE_URL}pos_api/pos_order_edit.php`, orderData)

      .then(response => {
        if (response.data.head.code === 200) {
          console.log("Order Saved:", response.data);
          alert("Order saved successfully!");
          const printWindow = window.open(`/invoice/${response.data.body.order_id}`, '_blank');
          setCart([]);
          setVehicleNumber(""); // Reset vehicle number
          //   window.location.reload();
          window.history.back();

        } else {
          console.log("Error", response.data.head.msg)
        }

      })
      .catch(error => {
        console.error("Save Order Error:", error);
        alert("Failed to save order.");
      }).finally(() => {
        setLoading2(false);
      });
  };







  // const handleCustomerSelect = (e) => {
  //     const selectedId = e.target.value;
  //     const selected = customer.find(c => c.user_id === selectedId);
  //     if (selected) {
  //       setSelectedCustomer({ 
  //         user_id: selected.user_id, 
  //         name: selected.name,
  //         phonenumber:selected.telephone, 
  //         is_bill_eligible: parseFloat(selected.is_bill_eligible) 
  //       });
  //     }
  //   };
  // console.log(selectedCustomer);


  const cleanText = (text) => (text ? text.replace(/[\u200B-\u200D\uFEFF]/g, "").trim().toLowerCase() : "");

  // const filteredProducts = fullproducts.filter((product) => {
  //   const search = cleanText(searchTerm);
  //   const productName = cleanText(product.product_name);
  //   const categoryName = cleanText(product.category_name);
  //   const brand = cleanText(product.brand);

  //   console.log(`Checking: Brand="${brand}", Search="${search}"`);

  //   return (
  //     productName.includes(search) ||
  //     categoryName.includes(search) ||
  //     brand.includes(search)
  //   );
  // });

  const handleQtyKeyDown = (e) => {
    // if (e.key === "Tab" && !e.shiftKey) {
    if (e.key === "Enter" || (e.key === "Tab" && !e.shiftKey)) {
      e.preventDefault();

      if (!productName || !price || !quantity) {
        alert("Please fill all fields");
        return;
      }

      // Add to cart
      const newItem = {
        product_id: Date.now(), // Unique ID
        product_name: productName,
        buy_price: parseFloat(price),
        // qty: parseInt(quantity),
        qty: quantity,
        hsn_code: "", // Add if needed
      };

      setCart((prev) => [...prev, newItem]);

      // Clear inputs
      setProductName("");
      setPrice("");
      setQuantity("");

      // Focus back to Product Name
      nameRef.current?.focus();
    }
  };

  const removeItem = (id, orderDetailId) => {
    setCart(cart.filter((item) => item.product_id !== id));
    handleDelete(orderDetailId);
  };



  const handleDelete = async (orderDetailId) => {
    if (!orderDetailId) return;

    try {
      const response = await axios.post(`${API_BASE_URL}order_detail_delete.php`, {
        order_detail_id: orderDetailId,
      });

      if (response.data.head.code === 200) {
        alert('order Deleted Successfully')
        //   closeModal();
        window.location.reload();

      } else {
        alert(response.data.head?.msg || "Failed to delete order");
      }

    }
    catch (error) {
      console.error("Error Deleting order", error)
    }

  };


  return (
    <Container fluid classNam e="p-3" style={{ minHeight: "100vh" }}>
      <Row>
        <Col
          md={12}
          className="border-end mt-2" style={{
            height: "95vh",
            display: "flex",
            flexDirection: "column",
          }}>

          {/* ✅ Layout for large screens (unchanged) */}
          <Row className=" mb-3 d-none d-md-flex align-items-center">
            <Col md={4}>
              <Form.Select
                value={selectedCustomer ? selectedCustomer.user_id : ""}
                onChange={(e) => {
                  const user = customer.find((c) => c.user_id === e.target.value);
                  setSelectedCustomer(user || null);
                }}
              >
                <option value="">Select Customer</option>
                {Array.isArray(customer) &&
                  customer.map((c) => (
                    <option key={c.user_id} value={c.user_id}>
                      {c.name}
                    </option>
                  ))}
              </Form.Select>
            </Col>

            <Col md={6}>
              <Form.Control
                type="text"
                placeholder="Address"
                value={selectedCustomer?.address || ""}
                readOnly
              />
            </Col>

            <Col md={1} className="d-flex gap-2">
              <Button variant="primary" onClick={handleShow}>
                <FaPlus />
              </Button>
              <Button
                className="btn btn-solid pos-back-btn"
                onClick={() => window.history.back()}
              >
                Back
              </Button>
            </Col>
          </Row>

          {/* ✅ Layout for small screens only */}
          <Row className="d-md-none">
            {/* Row 1: Customer Select + Buttons side-by-side */}
            <Col xs={12}>
              <Row className="align-items-center">
                <Col xs={8}>
                  <Form.Select
                    value={selectedCustomer ? selectedCustomer.user_id : ""}
                    onChange={(e) => {
                      const user = customer.find((c) => c.user_id === e.target.value);
                      setSelectedCustomer(user || null);
                    }}
                  >
                    <option value="">Select Customer</option>
                    {Array.isArray(customer) &&
                      customer.map((c) => (
                        <option key={c.user_id} value={c.user_id}>
                          {c.name}
                        </option>
                      ))}
                  </Form.Select>
                </Col>
                <Col xs={4} className="d-flex justify-content-end gap-2 mt-2">
                  <Button variant="primary" onClick={handleShow}>
                    <FaPlus />
                  </Button>
                  <Button
                    className="btn btn-solid pos-back-btn"
                    onClick={() => window.history.back()}
                  >
                    Back
                  </Button>
                </Col>
              </Row>
            </Col>

            {/* Row 2: Address Field */}
            <Col xs={12} className="mt-3 mb-3">
              <Form.Control
                type="text"
                placeholder="Address"
                value={selectedCustomer?.address || ""}
                readOnly
              />
            </Col>
          </Row>

          {/* </div> */}
          {/* </InputGroup> */}


          <Row>
            <Col md={4}>
              <InputGroup className="mb-3">
                <Form.Control
                  ref={nameRef}
                  type="text"
                  placeholder="Product Name"
                  value={productName}
                  onChange={(e) => setProductName(e.target.value)}
                  onKeyDown={(e) => {
                    if ((e.key === "Tab" && !e.shiftKey) || e.key === "Enter") {
                      e.preventDefault();
                      priceRef.current?.focus();
                    }
                  }}
                />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup className="mb-3">
                <Form.Control
                  ref={priceRef}
                  type="number"
                  placeholder="Price"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                  onKeyDown={(e) => {
                    if ((e.key === "Tab" && !e.shiftKey) || e.key === "Enter") {
                      e.preventDefault();
                      qtyRef.current?.focus();
                    }
                  }}
                />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup className="mb-3">
                <Form.Control
                  ref={qtyRef}
                  type="text"
                  placeholder="Quantity"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                  onKeyDown={handleQtyKeyDown} // ✅ Save and loop on Tab
                />
              </InputGroup>
            </Col>
          </Row>


          {/* Table to Display Selected Products */}
          <div style={{ flexGrow: 1, overflowY: "auto", border: "1px solid #ddd" }}>
            {/* <Table bordered responsive>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>HSN Code</th>
                  <th>Item</th>
                  <th style={{textAlign:"right"}}>Price</th>
                
                  <th>Qty</th>
                  <th style={{textAlign:"right"}}>Total</th>
                  <th>Del</th>
                </tr>
              </thead>
              <tbody>
                {cart.map((item, index) => (
                  <tr key={item.product_id}>
                    <td>{index + 1}</td>
                     <td>{item.hsn_code}</td>
                    <td>{item.product_name}</td>
                    <td style={{textAlign:"right"}}><BiRupee />{item.buy_price}</td>
                    
                    <td>
                    <input
                          type="number"
                          value={item.qty}
                          min="1"
                          // max={item.stock}
                          className="form-control text-center"
                          style={{ width: "60px" }}
                          onInput={(e) => handleQtyChange(e, item)}  // ✅ Works for both typing & button clicks
                          // onBlur={(e) => handleQtyBlur(e, item)}
                      />
                    </td>


                    <td style={{textAlign:"right"}}><BiRupee />{(item.buy_price * item.qty || 0).toFixed(2)} </td>
                    <td>
                      <Button variant="danger" size="sm" onClick={() => removeItem(item.product_id)}>
                        <FaTrash />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table> */}
            <Table bordered responsive>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>HSN Code</th>
                  <th>Item</th>
                  <th style={{ textAlign: "right" }}>Price</th>
                  <th>Qty</th>
                  <th style={{ textAlign: "right" }}>Total</th>
                  <th>Del</th>
                </tr>
              </thead>
              <tbody>
                {cart.map((item, index) => (
                  <tr key={item.product_id}>
                    <td>{index + 1}</td>
                    {/* <td>{item.hsn_code || "-"}</td> */}
                    <td>{hsnCode || "-"}</td>

                    <td>{item.product_name}</td>
                    <td style={{ textAlign: "right" }}>
                      <BiRupee />
                      {item.buy_price}
                    </td>
                    <td>
                      {/* <input
                        type="text"
                        value={item.qty}
                        min="1"
                        className="form-control text-center"
                        style={{ width: "60px" }}
                        onInput={(e) => handleQtyChange(e, item)}
                      /> */}
                      {(item.qty)}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <BiRupee />
                      {(item.buy_price * item.qty || 0).toFixed(2)}
                      {/* {(item.buy_price)} */}
                    </td>
                    <td>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => removeItem(item.product_id, item.order_detail_id)}
                      >
                        <FaTrash />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

          </div>

          <div className="bg-light p-3 border rounded d-flex justify-content-between print-btn-group">

            <div className="d-flex flex-column align-items-start gap-2">
              {/* Vehicle Number Input */}
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <label style={{ fontWeight: "bold", marginBottom: "0", whiteSpace: "nowrap", color: "black" }}>
                  Vehicle No:
                </label>
                <Form.Control
                  type="text"
                  placeholder="Enter Vehicle Number"
                  value={vehicleNumber}
                  onChange={(e) => setVehicleNumber(e.target.value)}
                  style={{ width: "200px" }}
                />
              </div>

              {/* Save Buttons */}
              <div className="print-btn d-flex">
                <Button variant="dark" onClick={handleSave} style={{ width: "80px", height: "40px" }}>

                  {Loading1 ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <>
                      <RiSave3Line /> &nbsp; Save
                    </>
                  )}
                </Button>

                &nbsp;&nbsp;

                <Button variant="dark" onClick={handleSavePrint} style={{ width: "130px", height: "40px" }}>
                  {Loading2 ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <>
                      <LuPrinter />&nbsp; Save & Print
                    </>
                  )}
                </Button>
              </div>
              
            </div>
            {/*     )} */}
            <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", width: "250px" }}>
                <h5 style={{ color: "black", fontWeight: "bold" }}>Sub-Total:</h5>
                <h5 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{calculateTotal()}</h5>
              </div>

              {selectedCustomer?.state?.toLowerCase() === "tamilnadu" ? (
                <>
                  <div style={{ display: "flex", justifyContent: "space-between", width: "250px" }}>
                    <h5 style={{ color: "black" }}>CGST:</h5>
                    <h5 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{cgstAmount.toFixed(2)}</h5>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", width: "250px" }}>
                    <h5 style={{ color: "black" }}>SGST:</h5>
                    <h5 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{sgstAmount.toFixed(2)}</h5>
                  </div>
                </>
              ) : (
                <div style={{ display: "flex", justifyContent: "space-between", width: "250px" }}>
                  <h5 style={{ color: "black" }}>IGST:</h5>
                  <h5 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{IgstAmount.toFixed(2)}</h5>
                </div>
              )}



              <div style={{ display: "flex", justifyContent: "space-between", width: "250px" }}>
                <h5 style={{ color: "black" }}>Packing Charge:</h5>
                <h5 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{packingCharge.toFixed(2)}</h5>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", width: "250px", fontWeight: "bold" }}>
                <h5 style={{ color: "black", fontWeight: "bold" }}>Grand Total:</h5>
                <h5 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{grandtotal.toFixed(2)}</h5>
              </div>
            </div>

          </div>

        </Col>

        {/* <Col md={6}>
      <Row>
        <Col md={7}>
          <InputGroup className="mb-3 mt-2">
            <Form.Control
              placeholder="Type category, product, or brand name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            &nbsp;&nbsp;
            <Button variant="primary" style={{marginTop:"0px"}}>
              <FaSearch />
            </Button>
          </InputGroup>
        </Col>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      
      </Row>
      <div style={{ overflowY: "scroll", height: "90vh", overflowX: "hidden" }}>
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "200px" }}
          >
            <div
              className="spinner-border text-primary"
              style={{ width: "3rem", height: "3rem" }}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <Row className="g-3">
            {Array.isArray(filteredProducts) && filteredProducts.length > 0 ? (
                    filteredProducts.map((product) => (
                      <Col lg={4} md={6} key={product.product_id}>
                        <Card className="text-center border" style={{ height: "150px", backgroundColor: "#dee3d6" }}>
                          <Card.Body>
                            <Card.Title style={{ fontSize: "12px", color: "black" }}>
                              {product.product_name}
                            </Card.Title>
                            <Card.Title style={{ fontSize: "12px" }}>{product.product_code}</Card.Title>
                            <Card.Text style={{ fontSize: "11px", fontWeight: "bold" }}>
                              Price: <BiRupee style={{ fontSize: "11px" }} />
                              {product.sell_price} <br />
                              Stock:
                              <span
                                style={{
                                  backgroundColor: product.stock > 10 ? "green" : "red",
                                  color: "white",
                                  padding: "3px 8px",
                                  borderRadius: "5px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  marginLeft: "5px",
                                  display: "inline-block",
                                }}
                              >
                                {product.stock}
                              </span>
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))
                  ) : (
                    <p style={{ textAlign: "center", fontWeight: "bold" }}>No products found</p>
                  )}

            </Row>
          </>
        )}
      </div>


    </Col> */}
      </Row>
      {/* -------------Customer Add Modal  Start --------------- */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            {/* agent Name */}
            <Form.Group className="mb-3">
              <Form.Label>Agent Name</Form.Label>
              <select
                className="form-control"
                name="agent"
                value={customer.agent}
                onChange={handleChange}
                required
              >
                <option value="">Select Agent</option>
                {agent.map((agent) => (
                  <option key={agent.agent_name} value={agent.agent_name}>
                    {agent.agent_name}
                  </option>
                ))}
              </select>
            </Form.Group>

            {/* Customer Name */}
            <Form.Group className="mb-3">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                type="text"
                name="customerName"
                value={formData.customerName}
                onChange={handleChange}
                placeholder="Enter Customer Name"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="text"
                name="phonenumber"
                value={formData.phonenumber}
                onChange={handleChange}
                placeholder="Enter Phone Number"
                required
                maxLength={10}
              />
            </Form.Group>



            {/* Address */}
            <Form.Group className="mb-3">
              <Form.Label>Address</Form.Label>
              <Form.Control
                as="textarea"
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="Enter Address"
                rows={3}

              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>State</Form.Label>
              <Form.Control
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                placeholder="Enter State"

              />
            </Form.Group>


            {/* GSTIN/UIN */}
            <Form.Group className="mb-3">
              <Form.Label>GSTIN/UIN</Form.Label>
              <Form.Control
                type="text"
                name="gstin"
                value={formData.gstin}
                onChange={handleChange}
                placeholder="Enter GSTIN/UIN"
                maxLength={15}
              />
            </Form.Group>

            {/* Aadhar Nbr */}
            <Form.Group className="mb-3">
              <Form.Label>Aadhar Number</Form.Label>
              <Form.Control
                type="text"
                name="aadhar_number"
                value={formData.aadhar_number}
                onChange={handleChange}
                placeholder="Enter Aadhar Number"
                maxLength={12}
              />
            </Form.Group>

            {/* Submit Button */}
            <Button variant="success" type="submit">
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      {/* -------------Customer Add Modal  End --------------- */}
    </Container>
  );
};

export default EditPOS;
